<template>
  <div>
    <slot />
    <div v-show="isLoading" :class="twMerge('py-3', props.loadingClass)">
      <etg-loading class="size-8 text-red-50 mx-auto" />
    </div>
    <div v-show="isAnchorShown" ref="anchorRef" class="anchor" />
  </div>
</template>

<script lang="ts" setup>
import type { HTMLAttributes } from 'vue'
import { twMerge } from 'tailwind-merge'

import EtgLoading from '@/components/common/etg-loading.vue'

interface Props {
  isLoading: boolean
  itemsCount: number
  totalCount: number
  threshold?: number
  distance?: number
  loadingClass?: HTMLAttributes['class']
}

interface Emits {
  (even: 'load-more'): void
}

const props = withDefaults(defineProps<Props>(), { threshold: 0.1, distance: 200 })
const emit = defineEmits<Emits>()

const anchorRef = ref<Nullable<HTMLDivElement>>(null)

const hasMoreItems = computed(() => props.itemsCount < props.totalCount)
const isAnchorShown = computed(() => !props.isLoading && hasMoreItems.value)

useIntersectionObserver(
  anchorRef,
  ([anchor]) => {
    if (!anchor.isIntersecting || !isAnchorShown.value) {
      return
    }

    emit('load-more')
  },
  { threshold: props.threshold, rootMargin: `${props.distance}px` }
)
</script>
